// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__39Pqf","notes":"Notes_notes__3Ipc9"};